import React from "react";
import Logo from "../assets/photo-gallery/logo.png";

export default function footer() {
    return (
        <div>
            <div className="contactSection">
                <div
                    className="phoneNumberSection"
                    data-aos="fade-right"
                    data-aos-delay="50">
                    <div className="faPart">
                        {" "}
                        <i className="fa fa-phone" aria-hidden="true"></i>
                    </div>
                    <div className=" infoPart ">
                        <h2>CALL TODAY</h2>
                        <h2>
                            <a href="tel:440-282-7147">440-282-7147</a>
                        </h2>
                    </div>
                </div>
                <div
                    className="adressSection"
                    data-aos="fade-right"
                    data-aos-delay="100">
                    <div className="faPart">
                        {" "}
                        <i className="fa fa-map" aria-hidden="true"></i>
                    </div>
                    <div className="infoPart">
                        <h2>OUR ADDRESS</h2>

                        <a
                            href="https://goo.gl/maps/RgsQJSEzK3NGUx2P6"
                            target="_blank">
                            <h2>
                                3500 Beavercrest Drive, Lorain, OH 44053
                            </h2>
                        </a>
                    </div>
                </div>
                <div
                    className="emailSection"
                    data-aos="fade-right"
                    data-aos-delay="150">
                    <div className="faPart">
                        {" "}
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                    </div>
                    <div className="infoPart">
                        <h2>EMAIL US</h2>
                        <h2>
                            {" "}
                            <a href="mailto:littlepeoplespalace@gmail.com">
                                littlepeoplespalace@gmail.com{" "}
                            </a>
                        </h2>
                    </div>
                </div>
            </div>

            <footer className="footer">
                <a href="#" className="logo">
                    <img src={Logo} />
                </a>
                <p>
                    {" "}
                    &#xA9; 2021
                    <a href="mailto:sbaslamisli@yahoo.com">
                        M.Sibel Baslamisli.
                    </a>
                    All rights reserved.
                </p>
            </footer>
        </div>
    );
}
